export enum LessonTableColumnName {
  Image = 'image',
  Title = 'title',
  Type = 'type',
  Status = 'status',
  Actions = 'actions'
}
